module.exports = __webpack_public_path__ + "static/media/kodflix-project.d8d01308.jpg";